module.exports = __webpack_public_path__ + "static/media/public.7a465937.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/public.png
// module id = 756
// module chunks = 0 1